import React from 'react'
import styled from 'styled-components'
import { Container } from '~/components/ui/Container'

const StyledCommonSection = styled.section`
  padding: 40px 0;
  background: ${props => props.theme.light2};
  overflow: hidden;
  &:nth-child(2n) {
    background: ${props => props.theme.light3};
  }

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
  }
  .section-title {
    flex: auto;
    font-size: 40px;
    line-height: 48px;
    font-weight: 600;
    color: ${props => props.theme.dark2};
  }
`

export const CommonSection: React.FC<{
  title: React.ReactNode
  extra?: React.ReactNode
  children: React.ReactNode
  style?: React.CSSProperties
}> = ({ title, extra, children, style }) => {
  return (
    <StyledCommonSection style={style}>
      <Container>
        <div className="section-header">
          <span className="section-title">{title}</span>
          {extra}
        </div>
      </Container>
      {children}
    </StyledCommonSection>
  )
}
